(function () {
  'use strict';

  angular
    .module('app')
    .component('receivedPaymentRelatedTransactions', receivedPaymentRelatedTransactions());

  function receivedPaymentRelatedTransactions() {
    return {
      bindings: {
        receivedPayment: '<',
        clientId: '<',
      },
      controller: ReceivedPaymentRelatedTransactionsComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/received-payments/components/received-payment-related-transactions/' +
        'received-payment-related-transactions.component.html',
    };
  }

  ReceivedPaymentRelatedTransactionsComponent.$inject = [
    'ReceivedPaymentService',
    'RelatedTransactionService',
  ];

  function ReceivedPaymentRelatedTransactionsComponent(
    ReceivedPaymentService,
    RelatedTransactionService
  ) {
    let vm = this;

    // Methoods
    vm.selectTransaction = selectTransaction;
    vm.openRelatedTransactionModal = openRelatedTransactionModal;

    vm.$onInit = function () {
      getRelatedTransactions();
    };

    function getRelatedTransactions() {
      vm.loadingRelatedTransactions = true;
      vm.relatedTransactions = ReceivedPaymentService.getRelatedTransactions(
        vm.receivedPayment,
        vm.clientId
      ).then(function (data) {
        vm.receivedPayment = data.received_payment;

        vm.bookings = data.bookings;
        vm.invoices = data.invoices;
        vm.incomingPrepayments = data.incomings;

        vm.loadingRelatedTransactions = false;
      });
    }

    function selectTransaction(transaction) {
      vm.transactionSelected = transaction;
      transaction.show = !transaction.show;
    }

    function openRelatedTransactionModal(transaction) {
      RelatedTransactionService.openRelatedTransactionModal(transaction);
    }
  }
})();
